export const replacePathParams = (
  path: string,
  params: Record<string, any>,
) => {
  return Object.keys(params).reduce((acc, paramName) => {
    return acc.replace(`:${paramName}`, params[paramName]);
  }, path);
};
